import { useEffect, useReducer } from 'react';
import { SHOPS_CITIES_URL } from '../sspr/constants';
import { parse_all_shops } from '../utils/utils';

const formatShopCities = (rawShopCities) => {
  if (!rawShopCities || !rawShopCities.shops) {
    return {
      slugifyNearby: [],
      parsedShops: [],
      name: '',
      villeStats: null,
      seoVille: null,
      villesProches: [],
    };
  }

  const parsedShops = parse_all_shops(rawShopCities.shops);
  let { nearby } = rawShopCities;
  nearby = (nearby || []).filter((city) => !!city);
  const slugifyNearby = nearby.map((city) => city);

  return {
    slugifyNearby,
    parsedShops,
    name: rawShopCities.name,
    villeStats: rawShopCities.ville_stats || null,
    seoVille: rawShopCities.seo_ville || null,
    villesProches: rawShopCities.villes_proches || [],
    deptSlug: rawShopCities.dept_slug || null,
  };
};

const initialState = {
  shopsCities: [],
  othersCities: [],
  name: '',
  villeStats: null,
  seoVille: null,
  villesProches: [],
  deptSlug: null,
  isLoading: true,
};

function reducer(state, action) {
  switch (action.type) {
    case 'FETCH_START':
      return { ...initialState, isLoading: true };
    case 'FETCH_SUCCESS':
      return {
        shopsCities: action.payload.parsedShops,
        othersCities: action.payload.slugifyNearby,
        name: action.payload.name,
        villeStats: action.payload.villeStats,
        seoVille: action.payload.seoVille,
        villesProches: action.payload.villesProches,
        deptSlug: action.payload.deptSlug,
        isLoading: false,
      };
    case 'FETCH_ERROR':
      return { ...initialState, isLoading: false };
    default:
      return state;
  }
}

const useShopsCities = (slug) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const controller = new AbortController();
    dispatch({ type: 'FETCH_START' });

    fetch(`${SHOPS_CITIES_URL}/${slug}`, { signal: controller.signal })
      .then((r) => r.json())
      .then((data) => {
        dispatch({ type: 'FETCH_SUCCESS', payload: formatShopCities(data) });
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('[useShopsCities] fetch failed:', err);
          dispatch({ type: 'FETCH_ERROR' });
        }
      });

    return () => controller.abort();
  }, [slug]);

  return state;
};

export default useShopsCities;
